<div class="app-shell">
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.4)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true">
    <p style="color: white"> Loading... </p>
  </ngx-spinner>
  <mat-toolbar class="topbar">
    <div class="topbar-inner">

      <!-- Left: Logo -->
      <div class="left">
        <img class="logo" [src]="logo" alt="Logo" />
      </div>

      <!-- Center: Nav -->
      <div class="center">
        <nav class="nav-pill" aria-label="Main navigation" *ngIf="userRoleRights?.includes('ViewClarityCommission')">

          <button mat-button routerLink="/home" routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }">
            Home
          </button>



          <button mat-button [matMenuTriggerFor]="configurationMenu" class="nav-menu-button" *ngIf="userRoleRights?.includes('ViewConfiguration')">
            <span>Configuration</span>
            <mat-icon>arrow_drop_down</mat-icon>
          </button>

          <!-- Configuration menu -->
          <mat-menu #configurationMenu="matMenu">
            <button mat-menu-item routerLink="/configuration/contributor" *ngIf="userRoleRights?.includes('ViewConfigurationContributors')">
              Contributor
            </button>

            <button mat-menu-item routerLink="/configuration/incentive-programs" *ngIf="userRoleRights?.includes('ViewConfigurationIncentivePrograms')">
              Incentive Programs
            </button>

            <!-- Plans submenu trigger -->
            <button mat-menu-item [matMenuTriggerFor]="plansMenu" *ngIf="userRoleRights?.includes('ViewConfigurationPlans')">
              Plans
            </button>

            <button mat-menu-item routerLink="/configuration/roles" *ngIf="userRoleRights?.includes('ViewConfigurationRoles')">
              Roles
            </button>

              <button mat-menu-item routerLink="/configuration/pending-approvals">
              Pending Approvals
            </button>
          </mat-menu>

          <!-- Plans submenu -->
          <mat-menu #plansMenu="matMenu">
            <button mat-menu-item routerLink="/configuration/plan/fixed-burden-plan">
              Fixed Burden Plans
            </button>

            <button mat-menu-item routerLink="/configuration/plan/permanent-plan">
              Permanent
            </button>

            <button mat-menu-item routerLink="/configuration/plan/commission-rate-template">
              Commission Rate Templates
            </button>

          </mat-menu>
          <button mat-button routerLink="/dashboard" routerLinkActive="active-link" *ngIf="userRoleRights?.includes('ViewContributorDashboard')">Dashboard</button>
          <button mat-button routerLink="/placement-ownership" routerLinkActive="active-link" *ngIf="userRoleRights?.includes('ViewMyPlacementOwnership')">Placements Ownerships</button>
          <button mat-button routerLink="/ownerships" routerLinkActive="active-link" *ngIf="userRoleRights?.includes('ViewOwnerships')">Ownerships</button>
          <button mat-button [matMenuTriggerFor]="commissionsMenu" routerLinkActive="active-link" class="nav-menu-button" *ngIf="userRoleRights?.includes('ViewMyCommissions')">
            <span>Commissions</span>
            <mat-icon>arrow_drop_down</mat-icon>
          </button>

          <mat-menu #commissionsMenu="matMenu">
            <button mat-menu-item routerLink="/commissions" routerLinkActive="active-link">Payout</button>
            <button mat-menu-item (click)="openContributorCommissionRateDialog()"
              routerLinkActive="active-link">Plan</button>
            <button mat-menu-item  routerLink="/commissions/estimator">Estimator</button>
            <button mat-menu-item (click)="openContractCalculationDialog()" routerLinkActive="active-link">Calculation
              Steps</button>
          </mat-menu>
          <!-- <button mat-button routerLink="/prepareCommissions" routerLinkActive="active-link">Prepare Commissions</button> -->
          <button mat-button [matMenuTriggerFor]="prepareCommissionsMenu" class="nav-menu-button" routerLinkActive="active-link" *ngIf="userRoleRights?.includes('ViewPreparedCommissions')">Prepare Commissions
            <mat-icon>arrow_drop_down</mat-icon>
          </button>
          <mat-menu #prepareCommissionsMenu="matMenu">
            <button mat-menu-item routerLink="/prepareCommissions" routerLinkActive="active-link">Prepare</button>
            <button mat-menu-item routerLink="/prepareCommissions/search-invoice" routerLinkActive="active-link">Search Invoice</button>
            <button mat-menu-item routerLink="/prepareCommissions/ingestion-control" routerLinkActive="active-link">Ingestion Control</button>
          </mat-menu>

          <button mat-button [matMenuTriggerFor]="reportsMenu" class="nav-menu-button" routerLinkActive="active-link" *ngIf="userRoleRights?.includes('ViewReports')">Reports
            <mat-icon>arrow_drop_down</mat-icon>
          </button>
          <mat-menu #reportsMenu="matMenu">
            <button mat-menu-item routerLink="/reports/assigned-incentive-programs" routerLinkActive="active-link">Incentive Programs</button>
            <button mat-menu-item routerLink="/reports/commission-rate-plan" routerLinkActive="active-link">Commission Plans</button>
            <button mat-menu-item routerLink="/reports/unpaid-perm-invoices" routerLinkActive="active-link">Unpaid Perm Invoices</button>
            <button mat-menu-item routerLink="/reports/invoice-placement-calculations" routerLinkActive="active-link">Invoice Placement Calculations</button>
            <button mat-menu-item routerLink="/reports/reconciliation" routerLinkActive="active-link">Reconciliation</button>
            <button mat-menu-item routerLink="/reports/ownership-changes" routerLinkActive="active-link">Ownership Changes</button>
            <button mat-menu-item routerLink="/reports/system-audit-history" routerLinkActive="active-link">System Audit History</button>
            <button mat-menu-item routerLink="/reports/retroactive-changes" routerLinkActive="active-link">Retroactive Changes</button>

          </mat-menu>

        </nav>
      </div>


      <!-- Right: User -->
      <div class="right">
        <button class="user-btn" mat-button [matMenuTriggerFor]="profileMenu">
          <div class="user-wrapper">

            <!-- Photo -->
            <ng-container *ngIf="hasPhoto; else noPhoto">
              <img [src]="profilePhoto" class="user-avatar" alt="User" />
            </ng-container>

            <ng-template #noPhoto>
              <mat-icon>account_circle</mat-icon>
            </ng-template>

            <!-- Name + Role -->
            <div class="user-info">
              <span class="user-name">
                {{ profile?.displayName }}
              </span>
              <span class="user-role">
                {{ userRole }}
              </span>
            </div>

            <!-- expand-icon -->
            <mat-icon class="expand-icon" *ngIf="isUserLogin">
              expand_more
            </mat-icon>

          </div>
        </button>

        <mat-menu #profileMenu="matMenu">
          <button mat-menu-item (click)="logout()" *ngIf="isUserLogin">
            <mat-icon>logout</mat-icon>
            Logout
          </button>
        </mat-menu>
      </div>

    </div>
  </mat-toolbar>

  <!-- Main Content if the user is Logged In & Roles are Loaded -->
  <div *ngIf="isUserLogin; else notLogin">
    <router-outlet></router-outlet>
  </div>
  <!-- <router-outlet></router-outlet> -->

  <!-- Main Content if the user is NOT Logged In -->
  <ng-template #notLogin>

    <div class="container-fluid text-center" *ngIf="!isUserLogin && !isUserRoleLoaded">
      <div class="container-fluid text-center login-section">
        <div class="row justify-content-center align-items-center">
          <div class="col-auto">
            <p class="mb-3">Please click the button below to log in and access the application.</p>
            <button mat-raised-button color="primary" (click)="loginPopup()">Login</button>
          </div>
        </div>
      </div>
    </div>

    <ng-template #LoadingRoles>
      <div class="row justify-content-center align-items-center">
        <div class="col-auto" *ngIf="doesUserHaveRole else accessDenied">
          <p class="mb-3">Loading user roles... Please wait.</p>
        </div>

        <ng-template #accessDenied>
          <div class="col-auto">
            <p class="mb-3">Access Denied: You do not have the required permissions to access this application.</p>
          </div>
        </ng-template>

      </div>
    </ng-template>
  </ng-template>


</div>
